import HCLTreeMxGraphDecoder from './HCLTreeMxGraphDecoder';
import BayesianNetworkMxGraph, {
  BayesianNetworkMxGraphJSON,
  BayesianNodeJSON
} from '../HCLTreeMxGraph/BayesianNetworkMxGraph';
import BayesianNetworkVertex from '../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertex';
import BayesianNetworkVertexValue from '../HCLTreeNode/BayesianNetworkNode/BayesianNetworkVertexValue';
import Label from "../HCLTreeNode/HCLTreeVertexValue/Label";
import InvalidJSONFormatError from "./InvalidJSONFormatError";

class BayesianNetworkMxGraphDecoder extends HCLTreeMxGraphDecoder {

  constructor(graph: BayesianNetworkMxGraph, json: BayesianNetworkMxGraphJSON) {
    // @ts-ignore
    super(graph, json);
  }

  private getVertexFromReference = (nodeJSON: {[key: string]: BayesianNodeJSON}) => {

    // add vertices
    const vertices = Object.entries(nodeJSON).map(entry => {
      const key = entry[0];
      const value = entry[1];
      const bayesianNetworkVertexValue = new BayesianNetworkVertexValue(Label.build(value.label), value.states, value.dependencies);
      const vertex = new BayesianNetworkVertex(key, bayesianNetworkVertexValue);
      return this.addVertex(vertex);
    });

    // add edges
    vertices.forEach(target => {

      const value = target.getValue() as BayesianNetworkVertexValue;
      const dependencies = value.getDependencies();

      dependencies.forEach(dependency => {
        const sources = this.graph.getVerticesMap()[dependency.name];
        if (sources.length === 0) throw new InvalidJSONFormatError(`Fatal Error: Failed to find dependency "${dependency.name}"`,nodeJSON);
        if (sources.length > 1) throw new InvalidJSONFormatError(`Fatal Error: There are more than one node whose name is ${dependency.name}`, nodeJSON);
        this.addEdgeBetween(sources[0], target);
      });
    });
  };

  /**
   * @override
   * @throw {InvalidJSONFormatError}
   */
  decode() {
    super.decode();
    const json = this.getJSON() as BayesianNetworkMxGraphJSON;
    this.getVertexFromReference(json.bayesian_nodes);
  }
}

export default BayesianNetworkMxGraphDecoder;
